import { FunctionComponent, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import store from '../../utils/store'

interface ContainerProps {
}

const Step20: FunctionComponent<ContainerProps> = (props) => {
    const [email, setEmail] = useState<string>('')
    const [emailSaved, setEmailSaved] = useState<boolean>()
    useEffect(() => {
        store.saveAnswerToFirestore()
    }, [])
    useEffect(() => {
        const f = async () => {
            const saved = await store.saveEmailToFirestore(email)
            setEmailSaved(saved)
        }
        f()
    }, [email])
    return (
        <div className="body2 container-fluid">
            <div className="row justify-content-center">
                <div className="col-md-11 topmarginend bottommargin">
                    <div style={{ textAlign: 'center'}}>
                        <span className="titulo">
                            <strong>¡MUCHAS GRACIAS POR PARTICIPAR!</strong>
                        </span>
                    </div>
                </div>
            </div>

            <div className="row justify-content-center">
                <div className="col-md-8 bottommargin">
                    <div style={{ textAlign: 'center'}}>
                        <span className="p" style={{fontSize: '1.3em', textAlign: 'center'}}>
                            Ingrese su email para comunicarnos y acceder a los resultados
                        </span>
                    </div>
                    <hr style={{ textAlign: 'center', width: '71px', border: '5px solid #70dace', borderRadius: '5px' }} />
                </div>
            </div>

            <div className="row justify-content-center">
                <div className="col-md-4">
                    <span style={{verticalAlign: 'inherit'}}>
                        <span className="p">
                            <div className="form-group">
                                <input
                                    id="email"
                                    type="email"
                                    className="form-control mr-sm-2 text-center"
                                    placeholder="Escriba su email aquí"
                                />
                                <input
                                    onClick={() => {
                                        const emailInput = (document.getElementById('email') as HTMLInputElement)
                                        setEmail(emailInput?.value)
                                    }}
                                    className="btn btn-primary"
                                    type="button"
                                    value="Enviar"
                                />
                            </div>
                            {emailSaved !== null && emailSaved !== undefined && emailSaved === true
                                && <div className="form-group">
                                    <div className="alert alert-primary text-center" role="alert">
                                        <p>¡Su email ha sido guardado con éxito!</p>
                                    </div>
                                </div>
                            }
                            {emailSaved !== null && emailSaved !== undefined && email !== '' && emailSaved === false
                                && <div className="form-group">
                                    <div className="alert alert-warning text-center" role="alert">
                                        <p>Ha ocurrido un error guardando su email</p>
                                    </div>
                                </div>
                            }
                        </span>
                    </span>
                </div>
            </div>

            <div className="row justify-content-center">
                <div className="col-md-4">
                    <div className="alert alert-success text-center" role="alert">
                        <p>¡Sus respuestas han sido guardadas con éxito!</p>
                        <Link to='/' className="button">Volver a empezar</Link>
                    </div>
                </div>
            </div>


            <div className="row topmargin justify-content-center">
                <div className="col-md-8 topmarginend bottommargin">
                    <div style={{ textAlign: 'center'}}>
                        <span className="p" style={{fontSize: '0.98em', textAlign: 'center'}}>
                            <p><strong>Desarrollo de contenidos temáticos:</strong></p>
                            <p>Dr. Marcelo Zárate</p>
                            <p><strong>Desarrollo informático:</strong></p>
                            <p>David Maximiliano Sosa</p>
                            <p><strong>Asesoramiento y soporte informático:</strong></p>
                            <p>Ing. Rec. Hid. Horacio Cesar Loyarte; Arq. María Victoria Paredes</p>
                            <p><strong>Diseño gráfico y maquetación web:</strong></p>
                            <p>Lic. Josefina Boscarol; Lic. María Alfonsina Reggiardo</p>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Step20;